import React from "react";
import { Box, Typography } from "@mui/material";
import { ArrowUp, ArrowDown } from "@phosphor-icons/react";
import { useTheme } from "@mui/material/styles";

interface ScoreItemProps {
  label: string;
  currentValue?: number;
  previousValue?: number;
}

const getDeltaPercent = (current?: number, previous?: number) => {
  if (current === undefined || previous === undefined) {
    return { delta: null, status: "equal" };
  }
  
  const delta = ((current - previous) / previous * 100);
  const deltaNum = parseFloat(delta.toFixed(2));
  
  if (deltaNum > 0) return { delta: Math.abs(deltaNum).toFixed(2), status: "up" };
  if (deltaNum < 0) return { delta: Math.abs(deltaNum).toFixed(2), status: "down" };
  return { delta: "0.00", status: "equal" };
};

export const ScoreItem: React.FC<ScoreItemProps> = ({ label, currentValue, previousValue }) => {
  const theme = useTheme();
  const { delta, status } = getDeltaPercent(currentValue, previousValue);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        {currentValue !== undefined && currentValue !== null ? (
          <>
            <Typography variant="h2" sx={{ fontSize: "32px", fontWeight: 500 }}>
              {currentValue}
            </Typography>

            {delta !== null && previousValue !== undefined && previousValue !== null && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {status === "up" && (
                  <ArrowUp 
                    weight="bold" 
                    color={theme.palette.success.main} 
                    size={16}
                  />
                )}
                {status === "down" && (
                  <ArrowDown 
                    weight="bold" 
                    color={theme.palette.error.main} 
                    size={16}
                  />
                )}
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontSize: "14px",
                    color: status === "up" 
                      ? theme.palette.success.main 
                      : status === "down"
                      ? theme.palette.error.main
                      : theme.palette.text.secondary
                  }}
                >
                  {delta}%
                </Typography>
              </Box>
            )}
          </>
        ) : (
          <Typography variant="h2" sx={{ fontSize: "32px", fontWeight: 500 }}>
            -
          </Typography>
        )}
      </Box>

      <Typography 
        variant="body2" 
        sx={{ 
          fontSize: "14px",
          color: theme.palette.text.secondary
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
